goog.require('el8.uiwidget.base');
goog.require('el8.app.setup');
goog.require('el8.data.practiceUsers');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.activityLog = {};

el8.main.activityLog.init = function(spec) {
    spec['layout'] = {innerContainerSelector: '#analytics-container', notLegacy: true};

    el8.data.practiceUsers.load();

    // // Connects the "Find Chart" header nav button to the "FindChartHeaderButton" React
    el8React.renderFindChartHeaderButton('react-chartnav');

    // Initializes el8 globals and enables legacy header nav links
    el8.app.setup(spec);
};
